<template>
    <div>

        <b-modal :active.sync="isComponentModalActive"
                 full-screen
                 has-modal-card  >

            <div class="modal-card ">

                <section class="modal-card-body"  >
                    <!-- Content ... -->


                    <editor
                         api-key="j42psxdlxzw597mdcz436lnnhg1u0rb8hfk5bwy8s6be2brr"
                         :init="{
                         height: 500,
                         menubar: false,
                         branding: false,
                         plugins: 'table',
                          toolbar: 'undo redo | formatselect |' +
                             'bold italic backcolor forecolor|checkbox' +
                              ' |table tabledelete | ' +
                             'tableprops tablerowprops tablecellprops | ' +
                             'tableinsertrowbefore tableinsertrowafter tabledeleterow |' +
                             ' tableinsertcolbefore tableinsertcolafter tabledeletecol'
                       }"
                      v-model="content"
                     />
                    {{ content }}

                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-danger" @click="close">Close</b-button>
                </footer>
            </div>

        </b-modal>


    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue'
    export default {
        name: "BlogTmce",
        components:{
            'editor': Editor
        },
        computed:{
            contentHtml : function () {
                 return  this.context
            }
        },
        methods:{
            close(){
               this.isComponentModalActive = false
            }
        },
        data(){
          return {
              content : "",
              isComponentModalActive: false
          }
        }

    }
</script>

<style scoped>

</style>